<!-- splash screen -->
<div #splashScreen id="splash-screen">
  <img src="./assets/media/for-mobile--full-t2u-1024x512.png" alt="Logo" width="200" />
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle
      class="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="5"
    ></circle>
  </svg>
</div>
